/**
 * Helper functions objects.js
 *
 * @namespace objects
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/helper/objects.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

/**
 * Performs a deep merge of objects and returns new object. Does not modify
 * objects (immutable) and merges arrays via concatenation.
 * @function objects.mergeDeep
 * @param {...object} objects - Objects to merge
 * @returns {object} New object with merged key/values
 */
export function mergeDeep(...objects) {
  const isObject = obj => obj && typeof obj === 'object';

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key];
      const oVal = obj[key];

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal);
      }
      else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      }
      else {
        prev[key] = oVal;
      }
    });

    return prev;
  }, {});
}

/**
 * clone an object using JSON, only works on objects that don't contain references/functions/classes
 * @function objects.simpleClone
 * @param object
 * @return {any}
 */
export function simpleClone(object){
  return JSON.parse(JSON.stringify(object));
}

/**
 * finds deep:  eg findDeep(object, "key1.key2") will return object[key1][key2] if it exists, otherwise return undefined
 *
 * @function objects.findDeep
 * @param object
 * @param combinedKey
 */
export function findDeep(object, combinedKey)
{
  combinedKey = combinedKey.split(".")
  let search = object

  for (let i=0; i<combinedKey.length;i++){
    if (typeof search[combinedKey[i]] === 'undefined')
      return
    else
      search = search[combinedKey[i]]
  }

  return search
}